<template>
  <div style="display: flex;" v-if="rowData">
    <el-switch
      active-color="#13ce66"
      inactive-color="#ad466c"
      v-model="rowData[params.colDef.field]"
      :disabled="isDisabled"
      style="margin:0 auto; display:block"
      class="mt-1"
      @change="handleSwitchChange($event, params.colDef.field)"
    ></el-switch>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'notificationSwitcher',
  methods: {
    handleSwitchChange(newValue, fieldType) {
      if (this.rowData.notificationHours > 0) {
        this.rowData[fieldType] = newValue;
        this.callParentDisableFunction(fieldType);
      } else {
        alert('Please add a Notification hours value to enable this option.');
        this.$nextTick(() => {
          this.rowData[fieldType] = !newValue;
        });
      }
    },
    callParentDisableFunction(field) {
      this.params.context.componentParent.disableUserNotification(
        this.rowData.uid,
        this.rowData[field],
        field
      );
    }
  },
  computed: {
    isDisabled() {
      return this.$store.state.allowNotifications === 'No' || this.$store.state.allowNotifications === null;
    },
    rowData() {
      return this.params.data;
    }
  }
});
</script>
